/*
  * 必要なライブラリ
  * Vue → JavaScriptの拡張
  * Vuetify → Vueをレイアウトメインでさらに拡張
  * axios → ページ内で非同期処理を行うために拡張
  */
import Vue from 'vue'
import vuetify from '../plugins/vuetify';
import axios from 'axios'
import MyCookie from '../components/MyCookie.vue'
//import MyLogin from '../components/MyLogin.vue'


Vue.mixin(MyCookie);

/*
  * 表示するvueファイル
  */
import App from './main.vue'

/*
  * もろもろの設定
  */
Vue.config.productionTip = true
Vue.use(axios);

/*
  * Vueインスタンスの生成
  */
new Vue({
  vuetify,
  render: h => h(App),
}).$mount('#app');